<template>
  <div class="ImportLibrariesTableComponent DataTables">
      <div :id="id"></div>
 </div>
</template>

<script>

  var $ = require('jquery');
  var jQuery = $
  window.$ = $
  window.jQuery = $
  var jquery = $;
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  require("datatables.net");
  require("datatables.net-bs4");



  import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'

  import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'


  //import { mapGetters } from 'vuex'
  import LibraryFilesType from '@/constants/LibraryFilesType'


export default {
  name: 'ImportLibrariesTableComponent',
  props:{
    lang: Object,
    data: Array
  },
  components: {

  },
  data () {
      return {
        name: "FormLibraryPropertiesComponent",
        id: "tableplace_"+this._uid,

        mainTable: "",
      }
  },
  computed: {
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    },
    importLibCurrentObject(){

      return this.$store.getters.importLibCurrentObject;
    },
    importLibCurrentObject_Result(){

      return this.$store.getters.importLibCurrentObject_Result;
    },
    checkActive(){

      return this.importLibCurrentObject.name + "__" + this.importLibCurrentObject.type;

    },
    checkResult(){

      return this.importLibCurrentObject_Result.name + "__" + this.importLibCurrentObject_Result.type;

    },
    dataLibrariesAfterBulkApprove(){

      return this.$store.getters.dataLibrariesAfterBulkApprove;
    }
  },
  created () {


  },
  mounted: function () {
    this.prepareData();
  },
  watch: {
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.prepareData(this.categoryId, this);

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    data: {
      handler: function(newVal, oldVal){

        this.prepareData();
      },
      deep: true

    },
    checkActive: {
      handler: function(newVal, oldVal){

        let o = document.getElementById("id__" + newVal);

        if (o != null){

          o.innerHTML = "<b-badge class='badge badge-warning '>Loading</b-badge>";

        }
      },
      deep: true

    },
    checkResult: {
      handler: function(newVal){

        let o = document.getElementById("id__" + newVal);
        let c = document.getElementById("id_check__" + newVal);

        let type = newVal.split("__");

        if (o != null){


          let res = "";
          let trig = true;

          let requiredFiles = this.checkRequired(this.importLibCurrentObject_Result.fileImportResults, type[1]);

          if (this.importLibCurrentObject_Result.fileImportResults == null){



            res = this.importLibCurrentObject_Result.message;
            trig = false;

          }else{

            for (const key in this.importLibCurrentObject_Result.fileImportResults) {

              let data = this.importLibCurrentObject_Result.fileImportResults[key].result;
              let d = "";
              if (data == "Successsfully uploaded to the server"){
                data = "Successfully uploaded to the server";
              }
              if (data == "Successsfully created on the server"){
                data = "Successfully created on the server";
              }
              if (data.toLowerCase() == "updated" || data.toLowerCase() == "added" || data.toLowerCase() == "identical" || data == "Successfully uploaded to the server" || data == "Successfully created on the server" || data == "Excluded file type." || data == "Excluded" || data == "Excluded by user's local configuration") {
                d = "<span class=\"green ellipse\"></span><span class=\"hiddentext\">3</span>";
              } else if (data.indexOf("Successful parsing") > -1) {
                d = "<span class=\"yellow ellipse\"></span><span class=\"hiddentext\">2</span>";

              } else {
                d = "<span class=\"red ellipse\"><span class=\"hiddentext\">1</span></span>";
                trig = false;
              }

              res += d + " <span class=\"nowrapForResult\" >" + this.checkExt([key], type[1])  + ": " + data + "</span><br>";


            }

          }



          let descr = "Done";
          let variant = "success";
          if (trig == false ){
            descr = "Error: Files were not uploaded correctly";
            variant = "danger";
          }
          if (requiredFiles == false){
            descr = "Error: The required files are missing";
            variant = "danger";
            if (c != null){

              c.checked = false;
            }
          }


          o.innerHTML = "<b-badge class='badge badge-"+variant+"'>" + descr + "</b-badge><br>" + res;

        }
      },
      deep: true

    },
    dataLibrariesAfterBulkApprove: {
      handler: function(newVal, oldVal){

        for (let i = 0, lei = this.$store.getters.dataLibrariesAfterBulkApprove.length; i < lei; i++){

          let name = this.$store.getters.dataLibrariesAfterBulkApprove[i].name;
          let type = this.$store.getters.dataLibrariesAfterBulkApprove[i].type;
          let status = this.$store.getters.dataLibrariesAfterBulkApprove[i].status;
          let message = this.$store.getters.dataLibrariesAfterBulkApprove[i].message;
          let variant = "info";
          let info = "";
          if (status == null){
            variant = "info";
            info = "Info";
            message = "The library was already active";
          }
          let o = document.getElementById("id__" + name + "__" + type);

          if (o != null){
            if (status == "success"){
              variant = "success";
              info = "Success";
              message = "";
            }else if (status == "error"){
              variant = "danger";
              info = "Error";

            }
            o.innerHTML = "<b-badge class='badge badge-" + variant + "'>" + info + "</b-badge><br><br>" + message;


          }
        }

      },
      deep: true

    },
  },
  methods: {
    prepareData() {
      this.libraries = [];


      for (let i = 0, lei = this.data.length; i < lei; i++){

        const obj = {
          index: i + 1,
          libraryId: this.data[i].libraryId,
          name: this.data[i].name,
          type: this.data[i].type,
          category: this.data[i].category,
          status: this.data[i].status,
          files: this.data[i].files.split(";"),
          path: this.data[i].path,
          message: this.data[i].message,
          select: this.data[i].status == "error" ? false : true
        }
        this.libraries.push(obj);


      }

      if (this.data.length > 0) {
        this.buildTable();
      }

    },
    checkCheckboxes() {

      let vue = this;

      const selected = [];

      $('#place' + this._uid + ' tbody input[type="checkbox"]').each(function () {

          const checked = $(this).is(':checked');
          if (vue.mainTable != ""){

            const rowData = vue.mainTable.row($(this).closest('tr')).data();


            if (rowData.select == true){

              selected.push(rowData);
            }

          }

      });
      this.$store.commit("SETCSVIMPORT", selected)
    },
    checkExt(data, type, br = false){

      let str = "";
      let exts = null;
      if (type == "footprint") {
        exts = LibraryFilesType.FOOTPRINT

      }
      if (type == "padstack") {
        exts = LibraryFilesType.PADSTACK

      }
      if (type == "shape") {
        exts = LibraryFilesType.SHAPE

      }
      if (type == "flash") {
        exts = LibraryFilesType.FLASH

      }
      if (type == "part" || type == "symbol") {
        exts = LibraryFilesType.PART;

      }
      if (type == "hdl symbol") {
        exts = LibraryFilesType.HDLSYMBOL;

      }
      if (type == "file") {
        exts = LibraryFilesType.FILE;

      }
      if (type == "mechanical") {
        exts = LibraryFilesType.MECHANICAL;

      }
      for (let i = 0, lei = data.length; i < lei; i++){

        let choosenExt = null;
        if (exts !== null){
          choosenExt = exts.some(ext =>
            data[i].toLowerCase().endsWith(ext.toLowerCase())
          );


        }

        if (choosenExt) {
          str += "<span class=\"highlighted-files\">" + data[i] + "</span>";
        } else {
          str += data[i];
        }
        if (br == true){

          str += "<br>";
        }

      }

      return str;

    },
    checkRequired(data, type){
      let isValid = false;

      if (data == null){

        return isValid;
      }

      let exts = null;
      if (type == "footprint") {
        exts = LibraryFilesType.FOOTPRINT

      }
      if (type == "padstack") {
        exts = LibraryFilesType.PADSTACK

      }
      if (type == "shape") {
        exts = LibraryFilesType.SHAPE

      }
      if (type == "flash") {
        exts = LibraryFilesType.FLASH

      }
      if (type == "part") {
        exts = LibraryFilesType.PART;

      }
      if (type == "symbol") {
        exts = LibraryFilesType.SYMBOL;

      }
      if (type == "hdl symbol") {
        exts = LibraryFilesType.HDLSYMBOL;

      }
      if (type == "file") {
        exts = LibraryFilesType.FILE;

      }
      if (type == "mechanical") {
        exts = LibraryFilesType.MECHANICAL;

      }

      let extObj = [];

      for (const key in data) {


        let choosenExt = null;
        if (exts !== null){

          choosenExt = exts.some(ext =>
            key.toLowerCase().endsWith(ext.toLowerCase())
          );
          if (choosenExt === true){
            extObj.push(choosenExt);
          }


        }

        isValid = extObj.length === exts.length && extObj.every(item => item === true);

      }


      return isValid;
    },
    buildTable(){


      let tableplace = document.getElementById("tableplace_"+this._uid);

      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }



      let place = document.createElement("table");
      place.setAttribute("id", "place"+this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      let tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      let thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      let tr2 = document.createElement("tr");
      tr2.setAttribute("class", "cellFooter");
      let tfoot = document.createElement("tfoot");
      tfoot.appendChild(tr2);
      place.appendChild(tfoot);

      let cols = [];

      let columnDefs = [];

      let columns = [
        {
          name: "Index",
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Category,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Files,
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Path,
          alignInColumn: "left",
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "center",

        },
        {
          name: this.lang.table_header_Message,
          alignInColumn: "center",

        },
        {
          name: this.lang.table_header_Select,
          alignInColumn: "center",

        },
        {
          name: this.lang.table_header_Progress,
          alignInColumn: "center",

        },

      ]

      let _vue = this;

      let len = columns.length;
      for (let i = 0; i < len; i++){



        let el = {};

        el = {
          targets: i,
          className: '_dt-body-'+ columns[i].alignInColumn,
          render: function (data, type, row, meta) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            let disabled = "";
            if (row.origins != "own"){
              disabled = "disabled=\"disabled\"";
            }
            if (meta.col == 0){

              return  data
            }else if (meta.col == 1){

              return data;
            }else if (meta.col == 2){

              return data;

            }else if(meta.col == 3){

              return data;
            } else if (meta.col == 4) {

              let str = _vue.checkExt(data, row.type, true);


              return str;
            } else if (meta.col == 5) {
              return data
            }else if(meta.col == 6){
              let variant = "success";
              if (data == "new revision"){
                return data;
              }
              if (data == "new library"){
                return data;
              }
              if (data == "error") {
                variant = "danger";
              }

              return "<span class='badge badge-"+variant+"'>" + data + "</span>";
            }else if(meta.col == 7){

              return data;
            }else if(meta.col == 8){

              let checked, disabled = "disabled";
              if (row.status != "error"){
                disabled = "";
                checked = "checked";
              }

              let str = "<div class=\"custom-control custom-checkbox\"><input "+disabled+" " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm  input-select\" id=\"id_check__" + row.name + "__" + row.type +"\" value=\""+ checked +"\"></div>";

              return  str;
            }else if(meta.col == 9){
              let str = "<span id=\"id__"+row.name+"__"+row.type+"\" class=\"result-box\"></span>";

              return str;

              //return "<div><span role=\"status\" class=\"spinner-border spinner-border-sm\"><span class=\"sr-only\">Small Spinner</span></span></div>";
            }


          }
        }



        columnDefs.push(el);



        cols =  [
            { "data": "index" },
            { "data": "name" },
            { "data": "type" },
            { "data": "category" },
            { "data": "files" },
            { "data": "path" },
            { "data": "status" },
            { "data": "message" },
            { "data": "select" },

        ]



        let th = document.createElement("th");
        //var th2 = document.createElement("th");
        tr1.appendChild(th);
        //tr2.appendChild(th2);
        //var p = document.createElement("p");
        //th.appendChild(p);
        let br = document.createElement("br");
        th.appendChild(br);

        let tx = document.createTextNode(columns[i].name)
        th.appendChild(tx);

      }




      let json = {};


      json.keys = false;
      json.data= this.libraries;
      json.myColumnFormats = columns;
      json.colReorder = false;
      json.paging = false;
      json.select = false;
      json.columns = cols;
      json.columnDefs = columnDefs;
      json.dom = '<f<t>ip>';
      json.order = [0, "asc"];
      json.ordering = true;

      json.initComplete = function () {

      }


      if ($.fn.dataTable.isDataTable('#place'+this._uid)) {
          this.mainTable.destroy();

      }



      this.mainTable = $('#place'+this._uid).DataTable(json);
      this.mainTable.one('draw.dt', function () {


        _vue.checkCheckboxes();

      });

      this.mainTable.columns.adjust().draw();



      //this.$parent.$parent.$parent.$parent.$parent.$parent.propsTable = this.mainTable;


      //hide first column in table
      //this.mainTable.column( 0 ).visible( false );
      //this.mainTable.column( 1 ).visible( false );



      //search input change view
      let searchplace = document.getElementById("place"+this._uid+"_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }


      searchplace.firstChild.setAttribute("placeholder", "Enter search words")
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm");
      searchplace.firstChild.setAttribute("id", "props_search");
      searchplace.firstChild.addEventListener("input", function(evt){

        _vue.$store.dispatch("setFilteredData", evt.target.value);

      })


      let checkboxes_input_select = document.getElementsByClassName("input-select");

      for (let i = 0; i < checkboxes_input_select.length; i++) {
        checkboxes_input_select[i].addEventListener('click', function (vue){

          let tr = $(this).closest('tr');
          let row = _vue.mainTable.row( tr );

          let data = row.data();

          const rowsArray = _vue.mainTable.rows().data().toArray();

          for (let el in rowsArray) {


            if (data.name == rowsArray[el].name && data.type == rowsArray[el].type) {

              rowsArray[el].select = this.checked;
            }
          }

          const selected = rowsArray.filter(obj => obj.select === true);

          _vue.$store.commit("SETCSVIMPORT", selected)


        }, false);
      }



    },


  }
}
</script>


<style lang="scss">
  @import "./../../scss/_custom.scss";

  .ImportLibrariesTableComponent{

    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .highlighted-files{
      color:orange;
    }
    .nowrapForResult{
      white-space: nowrap;
    }
    .ellipse{
      margin: 3px;
      height: 10px;
      width: 10px;
      border-radius: 50%;
    }
    .red {
      background-color: $red;
    }
    .green {
      background-color: $lightgreen;
    }
    .yellow {
      background-color: $yellow;
    }
    .hiddentext {
      font-size: 0px;
      float: left;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ImportLibrariesTableComponent.vue